import TriangleAlertSvg from '@assets/images/svg/triangle-alert.svg';
import React from 'react';

export interface TriangleAlertIconProps {
    size?: number;
    color?: string;
}

export const TriangleAlertIcon = React.memo<TriangleAlertIconProps>(function TriangleAlertIcon({ size = 20, color = '#333333' }) {
    return <TriangleAlertSvg width={size} height={size} color={color} />;
});

export default TriangleAlertIcon;
